var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cdn-topbar"},[_c('img',{staticClass:"cdn-topbar__logo",attrs:{"src":_vm.logo,"alt":""}}),_c('div',{staticClass:"cdn-topbar__right"},[_c('app-user-avatar',{attrs:{"name":_vm.username,"email":_vm.email,"profile-picture":_vm.user.picture}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }